import React from "react";

const rankNumeralClass = (rank) =>
  rank === 1
    ? "text-gem-amber"
    : rank === 2
      ? "text-gem-ruby"
      : rank === 3
        ? "text-gem-emerald"
        : "text-slate-500";

/**
 * Honest empty ranks as 004-style list rows: same row grid as paid seats
 * (rank numeral, "open slot", clicks/bid as —, Take). NO fake names, amounts,
 * or clicks — just an open slot and a TAKE #N · $1 button that opens the same
 * overlay as TRANSMIT (App maps a ghost rank to the $1 floor).
 *
 * Renders the ghost rows for the given `ranks` array. Ranks 1–3 numerals use
 * the gem colors (number only); 4+ stay slate. The caller decides which ranks
 * go where; this component just draws honest empty slots.
 */
export const GhostSeats = ({ ranks = [], onClaim }) => {
  if (!ranks.length) return null;

  return (
    <div data-testid="ghost-seats" className="mt-3 flex flex-col gap-2">
      {ranks.map((rank) => (
        <div
          key={rank}
          data-testid={`ghost-rank-${rank}`}
          className="listing-card flex min-w-0 flex-wrap items-center gap-x-3 gap-y-2 rounded-lg border border-[#141d34]/60 px-4 py-3"
        >
          <span className={`mono w-8 shrink-0 font-bold ${rankNumeralClass(rank)}`}>
            #{rank}
          </span>
          <div className="flex min-w-0 flex-1 basis-full flex-col sm:basis-48">
            <span className="truncate text-sm font-medium italic text-slate-600">
              open slot
            </span>
            <span className="mt-0.5 truncate text-[13px] leading-relaxed text-slate-600">
              {rank <= 3
                ? `Take this spot — pay $1 to claim #${rank}`
                : "Take this spot"}
            </span>
          </div>
          <span className="mono whitespace-nowrap text-xs text-slate-600">—</span>
          <span className="mono whitespace-nowrap text-slate-600">—</span>
          <button
            type="button"
            data-testid={`ghost-claim-${rank}`}
            onClick={() => onClaim && onClaim(rank)}
            className="mono inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-[#26324e] px-3 py-1.5 text-[11px] font-semibold tracking-wide text-slate-400 transition-colors hover:border-slate-400 hover:text-slate-200"
          >
            TAKE #{rank} · $1
          </button>
        </div>
      ))}
    </div>
  );
};
